import { useQuery } from '@tanstack/react-query'
import apiClient from '@/lib/api-client'
import type { StudioModel } from '@/components/v2/tools/generation/ModelSelector'

const AUDIT_MODEL_CODE = 'gemini-3.1-flash-image-preview'
const FALLBACK_RATIOS = ['1:1', '4:3', '3:4', '16:9', '9:16']
const FALLBACK_RESOLUTIONS = ['1k', '2k', '4k']

export interface AuditModelConfig {
  ratioOptions: string[]
  resolutionOptions: string[]
  maxReferenceImages: number
}

export function useAuditModelConfig(): AuditModelConfig & { isLoading: boolean } {
  const { data, isLoading } = useQuery({
    queryKey: ['studio-models'],
    queryFn: async () => {
      const res = await apiClient.get<{ models?: StudioModel[] } | StudioModel[]>('/api/v2/studio/models')
      const list = Array.isArray(res.data) ? res.data : (res.data.models ?? [])
      return list.find(m => m.code === AUDIT_MODEL_CODE) ?? list.find(m => m.is_default) ?? null
    },
    staleTime: 5 * 60 * 1000,
  })

  return {
    ratioOptions: data?.config.supported_aspect_ratios ?? FALLBACK_RATIOS,
    resolutionOptions: data?.config.supported_resolutions ?? FALLBACK_RESOLUTIONS,
    maxReferenceImages: data?.config.max_reference_images ?? 3,
    isLoading,
  }
}
